module.exports = __webpack_public_path__ + "img/getprize_img.d2f70bf9.png";